var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "article",
      {
        staticClass: "overflow-x-hidden overflow-y-auto",
        staticStyle: { "max-height": "100px" }
      },
      [
        _c("p", [
          _vm._v(
            "\n    El colegiado al inscribir en esta actividad a un acompañante mayor de edad se hará responsable de contar con el consentimiento expso previo del titular del dato para el conjunto de tratamientos que conlleva dicha actividad. Se abstendrá de realizar cualquier tratamiento de datos si no cuenta con dicho consentimiento. En todo caso, el COIICO no será del responsable de dicho tratamiento siendo en exclusiva del colegiado en este acto.\n  "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n    MENORES DE EDAD\n    El colegiado al inscribir en este evento a un acompañante menor de edad deberá:\n  "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n    Contar con la patria potestad del menor.\n    En caso de no contar con dicho título habilitante, deberá contar con el consentimiento expreso de los padres/tutores legales del menor.\n    En ambos casos, deberán estar en disposición de acreditar dicha condición, bien mediante el libro de familia o mediante documento notarial o judicial que sostenga dicha acreditación. El COIICO denegará la participación en estos eventos si el solicitante no contara con la habilitación legal pertinente. En todo caso, el COIICO no será responsable de dicho tratamiento siendo en exclusiva del colegiado en este caso.\n  "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n    CONSENTIMIENTO PARA ACCIONES PUBLICITARIAS Y MARKETING\n    La participación en este evento conlleva también su consentimiento expreso e inequívoco y el de las personas que le acompañan para poder realizar reportajes fotográficos, videos y emisión en directo de los eventos que este colegio celebre. También conlleva su consentimiento para poder dar divulgación a través de los canales de comunicación, redes sociales y página web del COIICO. Así como su publicación/divulgación a través de los canales de comunicación de los distintos patrocinadores cuando la actividad cuenten con patrocinador, para lo cual usted presta su consentimiento expreso e inequívoco.\n  "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n    ALERGIAS\n    La participación en algunas actividades puedo conllevar almuerzos, cenas o participación en comidas conjuntas. Si usted o alguno de las personas a las que usted inscriba tiene algún tipo de alergias alimentarias, deberá comunicar el número de personas que lo son y tipología de la alergia a fin de comunicar.\n  "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n    DESTINATARIOS\n    La participación es estos eventos puede conllevar la cesión y/o comunicación de sus datos personales así como de sus acompañantes a las entidades organizadoras o colaboradoras para el buen fin del mismo. Cada actividad indicará quién es el organizador del evento y, por tanto, quién será receptor de los datos en los casos que el acceso a los mismos estuviera motivado contractualmente.\n  "
          )
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }